import React from "react"
import Lottie from "@shared/uiNew/LazyLottie"

import FeatureCardsSection from "@shared/uiNew/FeatureCardsSection"
import lineAnimation from "@/shared/animations/circle.json"
import marketing_1 from "../assets/marketing_1.webp"
import marketing_2 from "../assets/marketing_2.png"

import * as styles from "../styles.module.scss"

const Marketing = (props) => (
  <FeatureCardsSection
    title={title}
    desc={subTitle}
    bubble={marketingBubble}
    cards={marketingArray}
    bgColor="#fff"
    buttonProps={{
      text: "Оставить заявку на демо",
      icon: "arrow",
      style: styles.marketingButton,
    }}
  />
)

export default Marketing

const title = (
  <h1 className={styles.marketingTitle}>
    Превращайте трафик{" "}
    <span className={styles.marketingHighlight}>
      в лиды
      <Lottie animationData={lineAnimation} loop={false} autoplay />
    </span>{" "}
    — без увеличения бюджета
  </h1>
)

const subTitle = <p className={styles.marketingDesc}>Собирайте заявки, квалифицируйте лиды и передавайте в продажи только самых горячих клиентов.</p>

const marketingBubble = (
  <h4 className={`${styles.bubble} ${styles.bubbleMarketing}`}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5492 10.9967C19.0942 9.97257 18.4328 9.0534 17.6063 8.29665L16.9242 7.67087C16.9011 7.65021 16.8732 7.63554 16.843 7.62816C16.8129 7.62078 16.7814 7.62092 16.7513 7.62856C16.7212 7.63619 16.6935 7.6511 16.6705 7.67196C16.6475 7.69282 16.63 7.71901 16.6195 7.74821L16.3148 8.62243C16.125 9.17087 15.7758 9.73103 15.2812 10.2818C15.2484 10.317 15.2109 10.3263 15.1852 10.3287C15.1594 10.331 15.1195 10.3263 15.0844 10.2935C15.0516 10.2654 15.0352 10.2232 15.0375 10.181C15.1242 8.77009 14.7023 7.17868 13.7789 5.44665C13.0148 4.00759 11.9531 2.88493 10.6266 2.10212L9.65859 1.53259C9.53203 1.45759 9.37031 1.55603 9.37734 1.70368L9.42891 2.82868C9.46406 3.59743 9.375 4.27712 9.16406 4.84196C8.90625 5.53337 8.53594 6.17556 8.0625 6.75212C7.73303 7.15282 7.35959 7.51525 6.94922 7.83259C5.96087 8.59235 5.15722 9.56587 4.59844 10.6802C4.04103 11.8043 3.75068 13.0419 3.75 14.2967C3.75 15.4029 3.96797 16.474 4.39922 17.4842C4.81562 18.4567 5.41654 19.3394 6.16875 20.0834C6.92813 20.8334 7.80938 21.424 8.79141 21.8342C9.80859 22.2607 10.8867 22.4763 12 22.4763C13.1133 22.4763 14.1914 22.2607 15.2086 21.8365C16.1882 21.4287 17.079 20.8341 17.8312 20.0857C18.5906 19.3357 19.1859 18.4592 19.6008 17.4865C20.0314 16.4791 20.2523 15.3946 20.25 14.299C20.25 13.1552 20.0156 12.0443 19.5492 10.9967Z"
        fill="#FC7C01"
      />
    </svg>
    Для маркетинга
  </h4>
)

const marketingArray = [
  {
    id: 1,
    title: "Сбор контактов и квалификация",
    text: "Чат-бот предложит подписаться на рассылку и соберет у посетителя сайта email сразу после захода на сайт.",
    image: marketing_1,
    imageAlt: "Сбор контактов и квалификация",
  },
  {
    id: 1,
    title: "Отправка триггерных сообщений",
    text: "При выполнении определенного действия (триггера) чат-бот поможет пользователю подобрать тариф, расскажет о дополнительных услугах компании и запишет на консультацию с менеджером.",
    image: marketing_2,
    imageAlt: "Отправка триггерных сообщений",
  },
]
